import { RowContainer } from 'components/Layout';
import { FilterItem } from './FilterItem';
import { useGetOrFiltersCallback } from './useGetOrFiltersCallback';
import styles from './filterItem.module.scss'
import { useMemo } from 'react';
import { GenericColumnModel, FilterType } from '../../models';
import { Translation } from 'components/Translations/Translation';

type Props = {
	filters: FilterType[]
	columns: GenericColumnModel[]
}

export const FilterItems = ({ filters, columns }: Props) => {
	const getOrFiltersCallback = useGetOrFiltersCallback(columns);

	const itemsContent = useMemo(
		() => {
			const content: React.ReactNode[] = [];
			for (let i = 0; i < filters.length; i++) {
				const filter = filters[i];

				if (filter.columnId && columns.find(column => filter.columnId === column.id)) {
					content.push(<FilterItem key={i} filter={filter} columns={columns} />);
					if (i < filters.length - 1) {
						content.push(<span className={styles.conjunction}>
							<Translation i18n={'i18n.label.filter.and'} />
						</span>);
					}
				}

				if (filter.orFilters && columns.find(column => filter.orFilters?.find(orFilter => orFilter.columnId === column.id))) {
					content.push(getOrFiltersCallback(filter.orFilters))
					if (i < filters.length - 1) {
						content.push(<span className={styles.conjunction}>
							<Translation i18n={'i18n.label.filter.and'} />
						</span>);
					}
				}
			}

			return content;
		},
		[columns, filters, getOrFiltersCallback]
	)

	return (
		<RowContainer alignItems='center' wrap='nowrap'>
			{itemsContent}
		</RowContainer>
	)
}
